
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

export default {
name:'headerItem',
components: {
Flexbox,
FlexboxItem
},
props: {

},
data() {
return {
};
},
methods: {
footerItem (url) {
window.open(url);
}
}
}



// WEBPACK FOOTER //
// ./src/views/footer/footer.vue